:host {
  all: initial;
  display: block;
  font-family: var(--zapier-font-family);
  color: var(--zapier-text-80);
}

/* We found that Safari wasn't taking into consideration the container queries
   when using the Host element as the container, so we had to re-write it and make
   changes to the elements adding a wrapper element below the Host. This we mainly
   needed due to Safari issue. On other browsers, we were able to use the Host element as the container.
   Check Sage's CodePen here https://codepen.io/wavebeem/pen/RwdVvJO
*/
.app-suggestions-host-container {
  container: app-suggestions-host-container;
  container-type: inline-size;
}

ul {
  scrollbar-color: var(--zapier-border-color) var(--zapier-bg-5);
  list-style: none;
  margin-block-start: 0;
  margin: 0;
  padding: 0;
  max-height: 350px;
  display: grid;
  column-gap: calc(var(--zapier-grid-unit) * 2);
  grid-template-columns: 1fr;
  overflow-y: auto;
  color-scheme: light dark;
}

li {
  flex: 1 0 calc(50% - 2 * var(--zapier-grid-unit));
  min-width: 280px;
  border-top: 1px solid var(--zapier-border-color);
  /* Accounts for focus and hover outlines for small screens */
  margin-right: 2px;
  margin-left: 2px;
}

/* Accounts for focus and hover outlines for small screens */
li:first-child {
  margin-top: 1px;
}

/* Accounts for focus and hover outlines for small screens */
li:last-child {
  margin-bottom: 1px;
  border-bottom: 1px solid var(--zapier-border-color);
}

.area {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: var(--zapier-grid-unit);
  display: flex;
  align-items: center;
  user-select: none;
  cursor: pointer;
  background: none;
  border: 0;
  appearance: none;
  font: inherit;
  font-weight: 600;
  outline: none;
  text-align: left;
  color: var(--zapier-text);
}

.area:hover {
  position: relative;
  color: var(--zapier-brand);
  outline: 1px solid;
}

.area:active,
.area:focus-visible {
  position: relative;
  color: var(--zapier-brand);
  outline: 2px solid;
  outline-offset: -1px;
}

.icon {
  width: calc(var(--zapier-grid-unit) * 4);
  height: calc(var(--zapier-grid-unit) * 4);
  margin-right: var(--zapier-grid-unit);
  padding: calc(var(--zapier-grid-unit) * 0.5);
  border: 1px solid var(--zapier-service-icon-border-color);
  border-radius: var(--zapier-grid-unit);
  background: var(--zapier-icon-bg);
  background-clip: padding-box;
  box-sizing: border-box;
}

.skeleton-app {
  width: 100%;
  flex-grow: 1;
  min-width: 200px;
  min-height: 62px;
  overflow: hidden;
  display: block;
  position: relative;
}

@keyframes loading {
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(100%);
  }
}

/* Container queries */
@container app-suggestions-host-container (min-width: 768px) {
  ul {
    grid-template-columns: 1fr 1fr;
    overflow-y: visible;
  }

  li {
    margin: 0;
  }

  li:nth-last-child(2) {
    border-bottom: 1px solid var(--zapier-border-color);
  }
}
